<template>
  <LightBox
    ref="lightbox"
    :showThumbs="$store.state.screenSize > 1"
    :show-light-box="false"
    :media="media"
    :nThumbs="$store.state.screenSize === 2 ? 4 : 7"
  >
    <div slot="previous" class="flex flex-col items-end lightbox-prev">
      <span>Previous</span>
      <icon class="icon mt-1" name="Arrow" />
    </div>

    <div slot="next" class="flex flex-col items-start lightbox-next">
      <span>Next</span>
      <icon class="icon transform -rotate-180 mt-1" name="Arrow" />
    </div>
  </LightBox>
</template>

<script>
import LightBox from 'vue-image-lightbox';
import Icon from '@components/Icon';

require('vue-image-lightbox/dist/vue-image-lightbox.min.css');

export default {
  name: 'ImageLightbox',
  components: { LightBox, Icon },
  props: {
    images: {
      default: () => [],
    },
    show: {
      default: false,
    },
  },
  computed: {
    media() {
      return this.images.map(i => {
        return {
          src: i.url,
          thumb: i.url,
        };
      });
    },
  },
  methods: {
    open(index) {
      this.$refs.lightbox.showImage(index);
    },
  },
};
</script>

<style scoped></style>
